const withinRange = (date, [rangeStart, rangeEnd]) => date && rangeStart && rangeStart < date && rangeEnd && rangeEnd > date, getSelectedState = ({
  selected,
  isRange,
  date
}) => {
  let type;
  if (isRange && date) {
    const [rangeStart, rangeEnd] = selected ?? [], isWithinTheRange = withinRange(date, [rangeStart, rangeEnd]);
    switch (!0) {
      case isWithinTheRange:
        type = "range";
        break;
      case date === rangeStart:
        type = rangeEnd ? "range-start" : "selected";
        break;
      case date === rangeEnd:
        type = rangeStart ? "range-end" : "selected";
        break;
    }
  } else
    (selected == null ? void 0 : selected[0]) === date && (type = "selected");
  return type;
};
export {
  getSelectedState,
  withinRange
};
//# sourceMappingURL=getSelectedState.js.map
